<template>
  <aside class="sidebar" :style="{width: elementWidth}">
    <!--      // TODO if you need change dragable element max size then set :max-width="400" value -->
    <vue-resizable :fit-parent="false" :active="['r']" :min-width="260" :max-width="400" @resize:move="eHandler"
      @resize:end="eHandlerEnd">
      <div class="resizable-content">
        <div class="sidebar-container">
          <div class="sidebar-header no-print">
            <div class="brand" :style="{width: elementWidth}">
              <span class="badge" v-if="isBeta">BETA</span>
              <div class="logo">
                <img src="/static/logo-menu.png" alt="Volta Analytics">
              </div>
            </div>
            <div class="customer-name">{{ customerName }}</div>
          </div>
          <nav class="menu">
            <ul class="sidebar-menu" id="sidebar-menu">
              <router-link tag="li" to="/" exact>
                <a><img src="/static/icons/icon-14.png" alt="dashboard" class="side-icon"> Dashboard
                  <font-awesome-icon class="arrow" icon="chevron-right" /></a>
              </router-link>
              <router-link tag="li" to="/charts" class="charts-menu" v-if="user.superAdmin || user.permissionMeasures">
                <div class="row">
                  <a class="col-10"><img src="/static/icons/icon-13.png" alt="misure" class="side-icon"> Misure
                  </a>
                  <a class="col-2 text-right" @click="toggleMeasuresTree">
                    <font-awesome-icon v-if="isExpandMeasuresTree" class="arrow arrow-down" icon="chevron-down" />
                    <font-awesome-icon v-else class="arrow arrow-right" icon="chevron-right" />
                  </a>
                </div>

                <div v-if="isMeasurePage" class="charts-tree">
                  <MeasuresTree v-show="isExpandMeasuresTree" />
                </div>
                <ul class="sidebar-nav" v-if="charts">
                  <router-link tag="li" v-for="(chart, i) in charts" :key="i" :to="'/charts/' + chart.userChartId">
                    <a>{{ chart.name }}</a>
                    <span @click="askRemove(chart.userChartId, chart.name)" class="del-chart">
                      <font-awesome-icon icon="times" />
                    </span>
                  </router-link>
                </ul>
              </router-link>

              <router-link tag="li" to="/diagnosi-energetica" v-if="user.superAdmin || user.permissionDe">
                <a><img src="/static/icons/icon-4.png" alt="Diagnosi energetica" class="side-icon"> Diagnosi energetica
                  <font-awesome-icon class="arrow" icon="chevron-right" /></a>

                <ul class="sidebar-nav">
                  <li>
                    <a class="jump" v-scroll-to="{ el: '#sankey', offset: -100 }">
                      <font-awesome-icon icon="chevron-right" />
                      Sankey</a>
                  </li>
                  <li>
                    <a class="jump" v-scroll-to="{ el: '#vettori-energetici', offset: -100 }">
                      <font-awesome-icon icon="chevron-right" />
                      Vettori energetici</a>
                  </li>
                  <template v-for="vector in vectors">
                    <li>
                      <a class="jump" v-scroll-to="{ el: '#modello-' + vector, offset: -100 }">
                        <font-awesome-icon icon="chevron-right" />
                        Modello energetico: {{ vectorName(vector) }}</a>
                    </li>
                    <li>
                      <a class="jump" v-scroll-to="{ el: '#allocazione-' + vector, offset: -100 }">
                        <font-awesome-icon icon="chevron-right" />
                        Allocazione {{ vectorName(vector) }}</a>
                    </li>
                  </template>
                </ul>
              </router-link>

              <router-link tag="li" to="/chart/indicators" class="charts-menu"
                v-if="user.superAdmin || user.permissionIndicators">
                <div class="row">
                  <a class="col-10"><img src="/static/icons/icon-5.png" alt="Indicatori" class="side-icon"> Indicatori
                  </a>
                  <a class="col-2 text-right" @click="toggleIndicatorsTree">
                    <font-awesome-icon v-if="isExpandIndicatorsTree" class="arrow arrow-down" icon="chevron-down" />
                    <font-awesome-icon v-else class="arrow arrow-right" icon="chevron-right" />
                  </a>
                </div>

                <div v-if="isIndicatorPage" class="charts-tree">
                  <IndicatorsTree v-show="isExpandIndicatorsTree" />
                </div>
              </router-link>

              <!--
                <router-link tag="li" to="/comingsoon1">
                  <a><img src="/static/icons/icon-5.png" alt="SGE ISO50001" class="side-icon"> SGE ISO50001
                    <font-awesome-icon class="arrow" icon="chevron-right" /></a>
                </router-link>
                <router-link tag="li" to="/comingsoon2">
                  <a><img src="/static/icons/icon-5.png" alt="Invoice" class="side-icon"> Invoice
                    <font-awesome-icon class="arrow" icon="chevron-right" /></a>
                </router-link>
                <router-link tag="li" to="/comingsoon3">
                  <a><img src="/static/icons/icon-5.png" alt="Controllo prestazionale" class="side-icon"> Controllo prestazionale
                    <font-awesome-icon class="arrow" icon="chevron-right" /></a>
                </router-link>
                
              --><router-link tag="li" to="/bill-audit/list"  v-if="user.superAdmin || user.permissionBillAudit">
                  <a>
                      <font-awesome-icon icon="money-bill-wave" /> Bill Audit
                      <font-awesome-icon class="arrow" icon="chevron-right" />
                  </a>
                </router-link>
              <router-link tag="li" to="/reports" v-if="user.superAdmin || user.permissionReports">
                <div class="row" @click="hideBackground">
                  <a class="col-10"><img src="/static/icons/icon-13.png" alt="misure" class="side-icon"> Reports
                  </a>
                  <a class="col-2 text-right" @click="toggleReportsTree">
                    <font-awesome-icon v-if="isExpandReportTree" class="arrow arrow-down" icon="chevron-down" />
                    <font-awesome-icon v-else class="arrow arrow-right" icon="chevron-right" />
                  </a>
                </div>
                <div v-if="isExpandReportTree">
                  <div class="report_tree">
                    <ul class="">
                      <li class="report_li" v-for="(report, index) in reportsList" :key="index"
                        @click="selectReport(report)"
                        :style="[selectedReportId==report.id && selectedReportId != null ? {'background': '#e58481'} : {'background': '#CF5651'}]">
                        <!-- <a class="jump" v-scroll-to="{ el: '#sankey', offset: -100 }">
                            <font-awesome-icon icon="chevron-right" />
                            Sankey</a></li> -->
                        <h6 class="report_name mb-0"> <font-awesome-icon icon="chevron-right" />&nbsp;{{report.name}}
                        </h6>
                      </li>
                    </ul>
                  </div>
                  <div v-if="getAdminStatus" class="report_tree">
                    <ul class="">
                      <li class="report_li" v-b-modal.modal_new_report @click="handleNewReportClick">
                        <!-- <font-awesome-icon icon="chevron-right" />&nbsp; -->
                        <h6 class="report_name mb-0">
                          <font-awesome-icon icon="plus" />&nbsp; Nuovo report
                        </h6>
                      </li>
                    </ul>
                    <!-- <span v-b-modal.modal_new_report @click="handleNewReportClick">+ Nuovo report</span> -->
                  </div>
                </div>
              </router-link>
            </ul>
          </nav>
        </div>
      </div>
    </vue-resizable>
    <b-modal ref="deleteChart" header-bg-variant="danger" ok-variant="danger" id="delete" title="Rimuovi grafico"
      @ok="removeChart" ok-title="Rimuovi" cancel-title="Annulla">
      <p>Rimuovere il grafico <strong>{{ chartName }}</strong> ?</p>
    </b-modal>
  </aside>
</template>

<script>
import IndicatorsTree from '../Charts/Tree/IndicatorsTree';
import MeasuresTree from '../Charts/Tree/MeasuresTree';
import VueResizable from 'vue-resizable';
const cookie = require('vue-cookie')
import { mapGetters } from 'vuex'


export default {
  name: 'Side',

  components: {
    IndicatorsTree,
    MeasuresTree,
    VueResizable
  },

  data () {
    return {
      customer: {},
      sitesToggle: false,
      chartName: '',
      chartId: null,
      vectors: [],
      expandMeasuresTree: true,
      expandIndicatorsTree: true,            
    }
  },
  
  created: function () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'diagnosi/setVectors') {
        this.vectors = state.diagnosi.vectors
      }
    });    
  },

  computed: {
    selectedReportId(){
      return this.$route.params.id;
    },
    elementWidth()  {
      return `${this.$store.state.elementWidthValue}px`
    },
    isBeta() {
      return location.host == "beta-analytics.voltaconsulting.it"
    },
    customerGuid() {
      return this.$store.state.customerGuid
    },
    customerName() {
      return this.$store.state.user.altCustomerName ? this.$store.state.user.altCustomerName : this.$store.state.user.customerName
    },
    isSuperAdmin() {
      return this.$store.state.user && this.$store.state.user.level == 1
    },
    charts() {
      if(this.$store.state.user.charts)
        return this.$store.state.user.charts.filter(c => !c.dashboard)
      return []
    },
    user() {
      return this.$store.state.user
    },
    currentPage() {
      return this.$route.name;
    },
    isMeasurePage() {
      return this.currentPage === 'Charts';
    },
    isIndicatorPage() {
      return this.currentPage === 'User indicators';
    },
    isExpandMeasuresTree() {
      return this.isMeasurePage && this.expandMeasuresTree;
    },
    isExpandReportTree() {
      return this.currentPage === 'ReportSection';
    },
    isExpandIndicatorsTree() {
      return this.isIndicatorPage && this.expandIndicatorsTree;
    },
    ...mapGetters({
      reportsList: 'report/getReportsList',
      getAdminStatus: 'getAdminStatus'

    }),
  },

  

  methods: {
    eHandler(data) {
      if(data.eventName == "resize:move") {
        let width = data.width;
        this.$store.dispatch('changeParentSize', width)
      }
    },
    eHandlerEnd(data) {
      if(data.eventName == "resize:end") {
        this.$cookie.set('menuWidth', data.width);
      }
    },
    toggleMeasuresTree() {
      if (!this.isMeasurePage) {
        this.expandMeasuresTree = true;
        this.$router.push('/charts');
        return;
      }
      this.expandMeasuresTree = !this.expandMeasuresTree;
    },

    toggleIndicatorsTree() {
      if (!this.isIndicatorPage) {
        this.expandIndicatorsTree = true;
        this.$router.push('/chart/indicators');
        return;
      }
      this.expandIndicatorsTree = !this.expandIndicatorsTree;
    },

    toggleReportsTree() {
      if (!this.isExpandReportTree) {
        this.isExpandReportTree = true;
        this.$router.push('/reports');
        return;
      }
      // this.expandIndicatorsTree = !this.expandIndicatorsTree;
    },
    hideBackground(){
        //  this.selectedReportId=null;
    },
    vectorName(vector) {
      return this.$store.getters['vectors/getName'](vector)
    },
    goToChart(chart) {
      this.$router.push({ name: 'Charts', params: { userChart: chart } })
    },
    removeChart() {
      this.$store.commit("loading");
      
      this.$store.dispatch('charts/deleteChart', this.chartId).then( (response) => {
        this.$store.dispatch('loadUser')
        
        this.$store.commit("stopLoading");
      })
    },
    askRemove(id, name) {
      this.chartName = name
      this.chartId = id
      this.$refs.deleteChart.show()
    },
    getIconClass(channel) {
      if(channel.mu) {
        if(channel.mu.toLowerCase() == "kwh") {
          return "electric"
        }
        if(channel.mu.toLowerCase() == "c") {
          return "thermal"
        }
      }
    },
    toggleSites() {
      this.sitesToggle = !this.sitesToggle
    },
    channelIcon(channel) {
      if(channel.mu == undefined)
        return "bolt"
      if(channel.mu.toLowerCase() == "kwh")
        return "bolt"
      else if(channel.mu.toLowerCase() == "c")
        return "thermometer-half"
      else
        return "bolt"
    },
    selectReport(report){
      // this.selectedReportId= report.id;
      this.$router.push('/reports/' + report.id);
    },
    handleNewReportClick(){
      this.$store.dispatch('report/toggleEditMode', false);
    }
  }
}
</script>
<style scoped>
/*.sidebar-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 293px;
}
*/
.resizable-content {
  height: 100%;
  width: 100%;
}
.sidebar .badge {
  position: absolute;
  top: 10px;
  right: 50px;
  color: yellow;
}
.sidebar .sidebar-menu li.menu-title {
  border-bottom: 2px solid;
  background: #2d363f;
  padding: 10px;
}
.sidebar .sidebar-menu li select {
  width:100%;
  height: 40px;
}
.sidebar .sidebar-menu li.menu-title a {
  color: #fff;
  font-weight: bold;
}
.sidebar .sidebar-menu li.active ul {
  display: block;
}
.sidebar .sidebar-menu > li > .row > a svg,
.sidebar .sidebar-menu > li > a svg {
    margin-right: 5px;
    font-size: 16px;
}
.sidebar .channels .electric {
  color: yellow;
}
.sidebar .channels .thermal {
  color: orange;
}
.logo {
  height: 67px;
  width: 141px;
  margin-left: 20px;
}
.logo img {
  width: 100%;
}
.sidebar svg {
  color:#fff;
}
.arrow {
  float: right;
  cursor: pointer;
}
.side-icon {
  width: 12px;
  display: inline-block;
  margin-right: 6px;
  line-height: 10px;
  margin-top: -2px;
}
a.jump {
  cursor: pointer;
}
.menu .row {
  margin-left: 0;
  margin-right: 0;
}
.menu .row a {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 15px;
}
.sidebar .sidebar-menu li:hover .row a,
.sidebar .sidebar-menu li.active .row > a,
.sidebar .sidebar-menu li.active .row a:hover {
    color: #ffffff;
    background-color: #DA7875;
}

.charts-menu .charts-tree {
  display: none;
}
.charts-menu.active .charts-tree {
  display: block;
}
.charts-menu.active .arrow-right {
  display: block;
}
.charts-menu.active.open .arrow-right {
  display: none;
}

.report_tree{
  /* padding-left: 42px; */
  color: white;
  /* padding-top: 7px; */
}
.report_name{
  cursor: pointer;
  font-size: 14px;
}
.report_li{
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 50px;
}
.report_li:hover{
  color: #ffffff;
  background-color: #e58481!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Side.vue